import { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";

import DialogActions from "../../../../../../shared/components/buttons/DialogActions";
import Dialog from "../../../../../Dialog/Dialog";
import useFeatureSwitches from "../../hooks/useFeatureSwitches";
import FeatureToggle from "./FeatureToggle/FeatureToggle";

interface FeatureSwitchesProps {
  onCloseDialog: () => void;
  isOpen: boolean;
}

const FeatureSwitches = ({ onCloseDialog, isOpen }: FeatureSwitchesProps) => {
  const { t } = useTranslation();

  const { featuresList, handleFeatureSwitches, resetToStoredValues } =
    useFeatureSwitches();
  const [isApplyLoading, setIsApplyLoading] = useState(false);

  const renderFeatureToggles = () =>
    featuresList.map(feature => {
      const { name, onToggle, isChecked } = feature;

      return (
        <FeatureToggle
          key={name}
          onToggle={onToggle}
          isChecked={isChecked || false}
          name={name}
        />
      );
    });

  const handleSubmit = async () => {
    setIsApplyLoading(true);
    handleFeatureSwitches(setIsApplyLoading, onCloseDialog);
  };

  const handleExited = useCallback(() => {
    // Reset after dialog has completely closed
    resetToStoredValues();
  }, [resetToStoredValues]);

  return (
    <Dialog
      data-testid="feature-switches-dialog"
      title={t("Dialog##feature switches##feature switches")}
      isTitleSeparator
      isActionsSeparator
      disableEnforceFocus
      disableRestoreFocus
      submit={handleSubmit}
      actions={
        <DialogActions
          onClose={onCloseDialog}
          isLoading={isApplyLoading}
          cancelButtonText={t("Button##close")}
          confirmationButtonText={t("Button##apply")}
          isreadyToConfirm
        />
      }
      close={onCloseDialog}
      slotProps={{ transition: { onExited: handleExited } }}
      open={isOpen}
    >
      {renderFeatureToggles()}
    </Dialog>
  );
};

export default FeatureSwitches;
